(function ($) {
  if (!$ || !$.fn.owlCarousel) return;

  //function initOwlCarousel(scope = document) {
  window.initOwlCarousel = function (scope = document) {
    $(scope)
      .find('.js-owl-carousel')
      .each(function () {
        const $carousel = $(this);

        // Prevent double init
        //if ($carousel.hasClass('owl-loaded')) return;
        if ($carousel.data('owl.carousel')) return;

        // Check if slider is enabled
        if ($carousel.data('enable') !== true && $carousel.data('enable') !== 'true') return;

        const rtl = $carousel.data('rtl') === true || $carousel.data('rtl') === 'true';
        const center_slides = $carousel.data('center-slides') === true || $carousel.data('center-slides') === 'true';
        const marginDesktop = Number($carousel.data('margin-desktop')) || 20;
        const marginMobile = Number($carousel.data('margin-mobile')) || marginDesktop;
        const autoplayEnabled = $carousel.data('autoplay') === true || $carousel.data('autoplay') === 'true';
        const autoplayTimeout = Number($carousel.data('autoplay-timeout')) || 5000;

        $carousel.owlCarousel({
          rtl: rtl,
          autoplay: autoplayEnabled,
          autoplayTimeout: autoplayTimeout,
          autoplayHoverPause: true,
          loop: $carousel.data('loop') === true || $carousel.data('loop') === 'true',
          nav: $carousel.data('nav') === true || $carousel.data('nav') === 'true',
          dots: $carousel.data('dots') === true || $carousel.data('dots') === 'true',
          autoplaySpeed: Number($carousel.data('speed')) || 600,
          navSpeed: Number($carousel.data('nav-speed')) || 600,
          dotsSpeed: Number($carousel.data('dots-speed')) || 600,
          smartSpeed: Number($carousel.data('smart-speed')) || 1200,
          slideTransition: 'ease-in-out',
          lazyLoad: true,
          stagePadding: marginDesktop,
          margin: marginDesktop,
          center: center_slides,

          navText: [
            `<span class="nav-btn-owl glass-effect">
              <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"/>
              </svg>
            </span>`,

            `<span class="nav-btn-owl glass-effect">
              <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"/>
              </svg>
            </span>`
          ],

          responsive: {
            0: {
              items: Number($carousel.data('items-mobile')) || 2,
              margin: marginMobile
            },
            768: {
              items: Number($carousel.data('items-desktop')) || 2,
              margin: marginDesktop
            },
            992: {
              items: Number($carousel.data('items-desktop')) || 3,
              margin: marginDesktop
            },
            1200: {
              items: Number($carousel.data('items-desktop')) || 4,
              margin: marginDesktop
            }
          }
        });

        // Accessibility
        setTimeout(() => {

          $carousel.find('.owl-prev').attr({
            'aria-label': 'Previous slide',
            'title': 'Previous slide'
          });

          $carousel.find('.owl-next').attr({
            'aria-label': 'Next slide',
            'title': 'Next slide'
          });

          $carousel.find('.owl-dot').each(function (i) {
            $(this).attr({
              'aria-label': 'Go to slide ' + (i + 1),
              'title': 'Go to slide ' + (i + 1)
            });
          });

        }, 50);

        // Equal height logic
        function setEqualHeight() {
          let maxHeight = 0;
          $carousel.find('.owl-item').each(function () {
            maxHeight = Math.max(maxHeight, $(this).height());
          });
          $carousel.find('.owl-item').height(maxHeight);
        }

        $carousel.on('initialized.owl.carousel resized.owl.carousel', function () {
          $carousel.find('.owl-item').css('height', 'auto');
          setEqualHeight();
        });
      });
  }

  // Normal page load
  $(document).ready(function () {
    initOwlCarousel();
  });

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initOwlCarousel(e.target);
  });

})(window.jQuery);

function equalizeOwlHeights() {
  document.querySelectorAll('.owl-carousel').forEach(carousel => {
    let maxHeight = 0;
    const items = carousel.querySelectorAll('.owl-item');

    // Reset heights first
    items.forEach(item => {
      item.style.height = 'auto';
    });

    // Find tallest
    items.forEach(item => {
      const h = item.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });

    // Apply equal height
    items.forEach(item => {
      item.style.height = maxHeight + 'px';
    });
  });
}

// Run on load
window.addEventListener('load', equalizeOwlHeights);

// Run after resize
window.addEventListener('resize', () => {
  setTimeout(equalizeOwlHeights, 200);
});

// Run after Owl init
$('.owl-carousel').on('initialized.owl.carousel refreshed.owl.carousel', function () {
  setTimeout(equalizeOwlHeights, 100);
});
